import OperationalReportListPage from './operationalReportListPage';

export default OperationalReportListPage;